// extracted by mini-css-extract-plugin
export var externalLink = "_7w-0";
export var internalLinkLabel = "_7w-1";